import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { growthBookInstance } from '../../utils/analytics/growthbook';
import { ABTestNamePhone } from '../../utils/enabled_features/ab_tests';

export const NameStep: Step = {
  id: 'name',
  pathname: '/name',
  canShow: (appData: AppData) => {
    if (appData.isFromMAL) return false;
    if (appData.isOnboardingLite) return false;
    if (growthBookInstance?.getFeatureValue(ABTestNamePhone.storageKey, 0) !== 0) {
      return false;
    }
    // If we're asking name on the partner landing page, we shouldn't show separate name step.
    return !appData.featureData?.askPhoneNamePrefilled;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !!appData.name,
  category: () => StepCategory.Account,
};
